module.exports = __webpack_public_path__ + "media/lobby_normal4.a49c6538.mp3";